module.exports = __webpack_public_path__ + "static/media/nextRank_1.c0bc8c48.mp3";